import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function OrderedListIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        d="M7.25 9.25V5.75L5.75 6.25M7.25 9.25H5.75M7.25 9.25H8.25M11.75 7.75H18.25M11.75 16.25H18.25M8.25 18.25H5.75L7.977 16.212C8.10227 16.0976 8.19002 15.948 8.22871 15.7828C8.2674 15.6176 8.25522 15.4446 8.19378 15.2864C8.13235 15.1283 8.02452 14.9924 7.88446 14.8967C7.7444 14.801 7.57865 14.7498 7.409 14.75H6.25C6.11739 14.75 5.99021 14.8027 5.89645 14.8964C5.80268 14.9902 5.75 15.1174 5.75 15.25"
        stroke="#344054"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
